var defaultVariantColorSets = function (theme) {
    return {
        primary: {
            normal: {
                foreground: theme.colors.PRIMARY.BACKGROUND,
                background: theme.colors.PRIMARY.FOREGROUND,
                border: theme.colors.PRIMARY.FOREGROUND
            },
            hover: {
                foreground: theme.colors.PRIMARY.FOREGROUND,
                background: theme.colors.PRIMARY.BACKGROUND,
                border: theme.colors.PRIMARY.FOREGROUND
            },
            active: {
                foreground: theme.colors.PRIMARY.FOREGROUND,
                background: theme.colors.PRIMARY.ACCENT_2,
                border: theme.colors.PRIMARY.FOREGROUND
            }
        },
        secondary: {
            normal: {
                foreground: theme.colors.PRIMARY.ACCENT_5,
                background: theme.colors.PRIMARY.BACKGROUND,
                border: theme.colors.PRIMARY.ACCENT_2
            },
            hover: {
                foreground: theme.colors.PRIMARY.FOREGROUND,
                background: theme.colors.PRIMARY.BACKGROUND,
                border: theme.colors.PRIMARY.FOREGROUND
            },
            active: {
                foreground: theme.colors.PRIMARY.FOREGROUND,
                background: theme.colors.PRIMARY.ACCENT_2,
                border: theme.colors.PRIMARY.FOREGROUND
            }
        },
        success: {
            normal: {
                foreground: theme.colors.PRIMARY.BACKGROUND,
                background: theme.colors.SUCCESS.DEFAULT,
                border: theme.colors.SUCCESS.DEFAULT
            },
            hover: {
                foreground: theme.colors.SUCCESS.DEFAULT,
                background: theme.colors.PRIMARY.BACKGROUND,
                border: theme.colors.SUCCESS.DEFAULT
            },
            active: {
                foreground: theme.colors.SUCCESS.DEFAULT,
                background: theme.colors.PRIMARY.ACCENT_2,
                border: theme.colors.SUCCESS.DEFAULT
            }
        },
        error: {
            normal: {
                foreground: theme.colors.PRIMARY.BACKGROUND,
                background: theme.colors.ERROR.DEFAULT,
                border: theme.colors.ERROR.DEFAULT
            },
            hover: {
                foreground: theme.colors.ERROR.DEFAULT,
                background: theme.colors.PRIMARY.BACKGROUND,
                border: theme.colors.ERROR.DEFAULT
            },
            active: {
                foreground: theme.colors.ERROR.DEFAULT,
                background: theme.colors.PRIMARY.ACCENT_2,
                border: theme.colors.ERROR.DEFAULT
            }
        },
        warning: {
            normal: {
                foreground: theme.colors.PRIMARY.BACKGROUND,
                background: theme.colors.WARNING.DEFAULT,
                border: theme.colors.WARNING.DEFAULT
            },
            hover: {
                foreground: theme.colors.WARNING.DEFAULT,
                background: theme.colors.PRIMARY.BACKGROUND,
                border: theme.colors.WARNING.DEFAULT
            },
            active: {
                foreground: theme.colors.WARNING.DEFAULT,
                background: theme.colors.PRIMARY.ACCENT_2,
                border: theme.colors.WARNING.DEFAULT
            }
        },
        alert: {
            normal: {
                foreground: theme.colors.PRIMARY.BACKGROUND,
                background: theme.colors.HIGHLIGHT.ORANGE,
                border: theme.colors.HIGHLIGHT.ORANGE
            },
            hover: {
                foreground: theme.colors.HIGHLIGHT.ORANGE,
                background: theme.colors.PRIMARY.BACKGROUND,
                border: theme.colors.HIGHLIGHT.ORANGE
            },
            active: {
                foreground: theme.colors.HIGHLIGHT.ORANGE,
                background: theme.colors.PRIMARY.ACCENT_2,
                border: theme.colors.HIGHLIGHT.ORANGE
            }
        },
        violet: {
            normal: {
                foreground: theme.colors.PRIMARY.BACKGROUND,
                background: theme.colors.VIOLET.DEFAULT,
                border: theme.colors.VIOLET.DEFAULT
            },
            hover: {
                foreground: theme.colors.VIOLET.DEFAULT,
                background: theme.colors.PRIMARY.BACKGROUND,
                border: theme.colors.VIOLET.DEFAULT
            },
            active: {
                foreground: theme.colors.VIOLET.DEFAULT,
                background: theme.colors.PRIMARY.ACCENT_2,
                border: theme.colors.VIOLET.DEFAULT
            }
        }
    };
};
var shadowVariantColorSets = function (theme) {
    return {
        primary: {
            normal: {
                foreground: theme.colors.PRIMARY.BACKGROUND,
                background: theme.colors.PRIMARY.FOREGROUND,
                border: theme.colors.PRIMARY.FOREGROUND
            },
            hover: {
                foreground: theme.colors.PRIMARY.BACKGROUND,
                background: theme.colors.PRIMARY.FOREGROUND,
                border: theme.colors.PRIMARY.FOREGROUND
            },
            active: {
                foreground: theme.colors.PRIMARY.BACKGROUND,
                background: theme.colors.PRIMARY.FOREGROUND,
                border: theme.colors.PRIMARY.FOREGROUND
            }
        },
        secondary: {
            normal: {
                foreground: theme.colors.PRIMARY.ACCENT_5,
                background: theme.colors.PRIMARY.BACKGROUND,
                border: theme.colors.PRIMARY.BACKGROUND
            },
            hover: {
                foreground: theme.colors.PRIMARY.ACCENT_5,
                background: theme.colors.PRIMARY.BACKGROUND,
                border: theme.colors.PRIMARY.BACKGROUND
            },
            active: {
                foreground: theme.colors.PRIMARY.ACCENT_5,
                background: theme.colors.PRIMARY.BACKGROUND,
                border: theme.colors.PRIMARY.BACKGROUND
            }
        },
        success: {
            normal: {
                foreground: theme.colors.PRIMARY.FOREGROUND,
                background: theme.colors.SUCCESS.DEFAULT,
                border: theme.colors.SUCCESS.DEFAULT
            },
            hover: {
                foreground: theme.colors.PRIMARY.FOREGROUND,
                background: theme.colors.SUCCESS.DEFAULT,
                border: theme.colors.SUCCESS.DEFAULT
            },
            active: {
                foreground: theme.colors.PRIMARY.FOREGROUND,
                background: theme.colors.SUCCESS.DEFAULT,
                border: theme.colors.SUCCESS.DEFAULT
            }
        },
        error: {
            normal: {
                foreground: theme.colors.PRIMARY.FOREGROUND,
                background: theme.colors.ERROR.DEFAULT,
                border: theme.colors.ERROR.DEFAULT
            },
            hover: {
                foreground: theme.colors.PRIMARY.FOREGROUND,
                background: theme.colors.ERROR.DEFAULT,
                border: theme.colors.ERROR.DEFAULT
            },
            active: {
                foreground: theme.colors.PRIMARY.FOREGROUND,
                background: theme.colors.ERROR.DEFAULT,
                border: theme.colors.ERROR.DEFAULT
            }
        },
        warning: {
            normal: {
                foreground: theme.colors.PRIMARY.FOREGROUND,
                background: theme.colors.WARNING.DEFAULT,
                border: theme.colors.WARNING.DEFAULT
            },
            hover: {
                foreground: theme.colors.PRIMARY.FOREGROUND,
                background: theme.colors.WARNING.DEFAULT,
                border: theme.colors.WARNING.DEFAULT
            },
            active: {
                foreground: theme.colors.PRIMARY.FOREGROUND,
                background: theme.colors.WARNING.DEFAULT,
                border: theme.colors.WARNING.DEFAULT
            }
        },
        alert: {
            normal: {
                foreground: theme.colors.PRIMARY.FOREGROUND,
                background: theme.colors.HIGHLIGHT.ORANGE,
                border: theme.colors.HIGHLIGHT.ORANGE
            },
            hover: {
                foreground: theme.colors.PRIMARY.FOREGROUND,
                background: theme.colors.HIGHLIGHT.ORANGE,
                border: theme.colors.HIGHLIGHT.ORANGE
            },
            active: {
                foreground: theme.colors.PRIMARY.FOREGROUND,
                background: theme.colors.HIGHLIGHT.ORANGE,
                border: theme.colors.HIGHLIGHT.ORANGE
            }
        },
        violet: {
            normal: {
                foreground: theme.colors.PRIMARY.FOREGROUND,
                background: theme.colors.VIOLET.DEFAULT,
                border: theme.colors.VIOLET.DEFAULT
            },
            hover: {
                foreground: theme.colors.PRIMARY.FOREGROUND,
                background: theme.colors.VIOLET.DEFAULT,
                border: theme.colors.VIOLET.DEFAULT
            },
            active: {
                foreground: theme.colors.PRIMARY.FOREGROUND,
                background: theme.colors.VIOLET.DEFAULT,
                border: theme.colors.VIOLET.DEFAULT
            }
        }
    };
};
var ghostVariantColorSets = function (theme) {
    return {
        primary: {
            normal: {
                foreground: theme.colors.PRIMARY.FOREGROUND,
                background: 'none',
                border: 'transparent'
            },
            hover: {
                foreground: theme.colors.PRIMARY.FOREGROUND,
                background: theme.colors.PRIMARY.ACCENT_4,
                border: 'transparent'
            },
            active: {
                foreground: theme.colors.PRIMARY.FOREGROUND,
                background: theme.colors.PRIMARY.ACCENT_4,
                border: 'transparent'
            }
        },
        secondary: {
            normal: {
                foreground: theme.colors.PRIMARY.ACCENT_5,
                background: 'none',
                border: 'transparent'
            },
            hover: {
                foreground: theme.colors.PRIMARY.ACCENT_5,
                background: theme.colors.PRIMARY.ACCENT_4,
                border: 'transparent'
            },
            active: {
                foreground: theme.colors.PRIMARY.ACCENT_5,
                background: theme.colors.PRIMARY.ACCENT_4,
                border: 'transparent'
            }
        },
        success: {
            normal: {
                foreground: theme.colors.SUCCESS.DEFAULT,
                background: 'none',
                border: 'transparent'
            },
            hover: {
                foreground: theme.colors.SUCCESS.DEFAULT,
                background: theme.colors.SUCCESS.DEFAULT,
                border: 'transparent'
            },
            active: {
                foreground: theme.colors.SUCCESS.DEFAULT,
                background: theme.colors.SUCCESS.DEFAULT,
                border: 'transparent'
            }
        },
        error: {
            normal: {
                foreground: theme.colors.ERROR.DEFAULT,
                background: 'none',
                border: 'transparent'
            },
            hover: {
                foreground: theme.colors.ERROR.DEFAULT,
                background: theme.colors.ERROR.DEFAULT,
                border: 'transparent'
            },
            active: {
                foreground: theme.colors.ERROR.DEFAULT,
                background: theme.colors.ERROR.DEFAULT,
                border: 'transparent'
            }
        },
        warning: {
            normal: {
                foreground: theme.colors.WARNING.DEFAULT,
                background: 'none',
                border: 'transparent'
            },
            hover: {
                foreground: theme.colors.WARNING.DEFAULT,
                background: theme.colors.WARNING.DEFAULT,
                border: 'transparent'
            },
            active: {
                foreground: theme.colors.WARNING.DEFAULT,
                background: theme.colors.WARNING.DEFAULT,
                border: 'transparent'
            }
        },
        alert: {
            normal: {
                foreground: theme.colors.HIGHLIGHT.ORANGE,
                background: 'none',
                border: 'transparent'
            },
            hover: {
                foreground: theme.colors.HIGHLIGHT.ORANGE,
                background: theme.colors.HIGHLIGHT.ORANGE,
                border: 'transparent'
            },
            active: {
                foreground: theme.colors.HIGHLIGHT.ORANGE,
                background: theme.colors.HIGHLIGHT.ORANGE,
                border: 'transparent'
            }
        },
        violet: {
            normal: {
                foreground: theme.colors.VIOLET.DEFAULT,
                background: 'none',
                border: 'transparent'
            },
            hover: {
                foreground: theme.colors.VIOLET.DEFAULT,
                background: theme.colors.VIOLET.DEFAULT,
                border: 'transparent'
            },
            active: {
                foreground: theme.colors.VIOLET.DEFAULT,
                background: theme.colors.VIOLET.DEFAULT,
                border: 'transparent'
            }
        }
    };
};
var colorVariantSets = {
    default: defaultVariantColorSets,
    ghost: ghostVariantColorSets,
    shadow: shadowVariantColorSets
};
export var createColorSets = function (variant, theme, color) {
    return colorVariantSets[variant](theme)[color];
};
//# sourceMappingURL=type.js.map